import Model from "./Model";
import Content from "./ContentModel";
import ContentModel from './ContentModel';

export default class EssayReplyModel extends Model {
  id: number;
  status: string;
  position: number;
  updatedAt: Date;
  questionId: number;
  contentIds: number[];
  correctionIds: number[];

  static __typename: string = "EssayReply";

  constructor(essayReply: any, getters: any) {
    super(getters);
    this.id = essayReply.id;
    this.status = essayReply.status;
    this.position = essayReply.position;
    this.correctionIds = essayReply.correctionsByEssayReplyId;
    this.updatedAt = new Date(essayReply.updatedAt);
    this.questionId = essayReply.questionByQuestionId || essayReply.questionId;
  }
  subject() {
    return this.getters.subjectById(this.questionId);
  }
  contents() {
    return this.getters
      .contentsByEssayReplyId(this.id)
      .concat()
      .sort((A: ContentModel, B: ContentModel) => A.position - B.position);
  }
  link() {
    let subject = this.subject();
    if (subject.link) {
      if (this.status == "DRAFT") {
        //return `${this.subject().link()}/${this.position+1}`
        return this.subject().link();
      } else {
        //return `${this.subject().link()}/${this.position+1}/correcao`
        return `${this.subject().link()}/correcao`;
      }
    } else {
      return "/";
    }
  }
  imageAnswer() {
    let content = this.contents().find((content: Content) => !!content.imageId);
    if (content) {
      return content.image()
    } else {
      return {}
    }
  }
  textAnswer() {
    let content = this.contents().find((content: Content) => !!content.textId);
    if (content) {
      return content.text();
    } else {
      return {body: ""};
    }
  }
  completed() {
    if ((this.status == "DRAFT")) {
      // completed should never be more than 99% if essay is still a draft
      // 2840 is the average length of a perfect essay
      // 2300 is minimum lenght of a perfect essay
      // todo: a better metric than character length should be used
      return Math.min(
        99,
        Math.round((100 * this.textAnswer().body.length) / 2300)
      );
    } else {
      return 100;
    }
  }
  corrections() {
    if (this.correctionIds) {
      return this.correctionIds.map((correctionId: number) =>
        this.getters.correctionById(correctionId)
      );
    } else {
      return [];
    }
  }
  correction() {
    return this.corrections()[0];
  }
}